import { Dispatch, SetStateAction, useState } from 'react';
import { P3 } from '../../../styles/FontStyles';
import { color } from '../../../styles/GlobalStyles';

import { PurchaseEarnBetSteps } from '../EarnBet.types';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { formatUSD, USDT } from '../../../helpers/helperFunctions';
import { useAppSelector } from '../../../app/hooks';
import { SmallTxt } from '../../Earnings/Withdraw/WithdrawStyled';
import { useDispatch } from 'react-redux';
import { transferToEarnBet } from '../../Earnings/TranferToEarnBet/Transfer.actions';
import { EarnBetTransfer } from '../../Earnings/TranferToEarnBet/Transfer.types';

interface ConfirmDepositProps {
  setTransferStep: Dispatch<SetStateAction<number>>;
  price: number;
}

export const ConfirmDeposit = ({
  setTransferStep,
  price
}: ConfirmDepositProps) => {
  const { info } = useAppSelector((state) => state.earnings);

  const dispatch = useDispatch();

  return (
    <>
      <P3 bold mb='25' color={color.colors.error500}>
        This deposit carries no BV and does not qualify for any compensation
        payout.
      </P3>
      <Button
        mb='10'
        onClick={() => {
          dispatch(
            transferToEarnBet({
              cash: price,
              usdt: 0,
              usdc: 0,
              networkType: 3,
              isEarnBetTransfer: EarnBetTransfer.isEarnBetTransfer,
              setTransferStep
            })
          );
        }}>
        Pay with Cash account
      </Button>
      <Flexed between mb='30'>
        <SmallTxt>
          Current Cash account balance:{' '}
          {formatUSD(info?.totalEarnings?.availableBalance)} {USDT}
        </SmallTxt>
        <SmallTxt>Min transfer amount: 10 {USDT}</SmallTxt>
      </Flexed>
      <Button
        onClick={() => setTransferStep(PurchaseEarnBetSteps.SELECT_PAYMENT)}>
        Pay with USDT (Tether)
      </Button>
      <Flexed between mt='10'>
        <div></div>
        <SmallTxt>Min transfer amount: 10 {USDT}</SmallTxt>
      </Flexed>
    </>
  );
};
